module.exports = __webpack_public_path__ + "static/media/16UNODC15.d04c8aec.jpg";